module.exports = __webpack_public_path__ + "f8142f04743af125d8d8f75a22169a90.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-blue-s.png
// module id = 2415
// module chunks = 0